import { useCallback, useState } from 'react'

export const useForce = () => {
  const [, setV] = useState(0)
  return useCallback(() => {
    setV(v => (v + 1) & 0xff)
  }, [])
}
